// Mock clients with orders behavior for scoring.
// statuses: confirmed | cancelled | returned
// responded: accepted calls/messages
// delivered: delivery success
// paid: good payment behavior
export const clientsSeed = [
  {
    id: "cl_1001",
    fullName: "Sara El Amrani",
    phone: "+212 6 12 34 56 78",
    email: "sara@example.com",
    city: "Casablanca",
    address: "Maarif, Rue 12",
    notes: "Prefers WhatsApp confirmations.",
    manualRiskFlag: false,
    blocked: false,
    createdAt: "2025-09-12",
    orders: [
      { id: "ord_901", status: "confirmed", amount: 499, createdAt: "2025-10-03", responded: true, delivered: true, paid: true },
      { id: "ord_944", status: "confirmed", amount: 299, createdAt: "2025-11-18", responded: true, delivered: true, paid: true },
      { id: "ord_1002", status: "cancelled", amount: 199, createdAt: "2025-12-01", responded: false, delivered: false, paid: false },
      { id: "ord_1110", status: "confirmed", amount: 899, createdAt: "2026-01-10", responded: true, delivered: true, paid: true },
    ],
  },
  {
    id: "cl_1002",
    fullName: "Youssef Benali",
    phone: "+212 6 98 76 54 32",
    email: "youssef@example.com",
    city: "Rabat",
    address: "Agdal, Avenue 5",
    notes: "Often unreachable after ordering.",
    manualRiskFlag: false,
    blocked: false,
    createdAt: "2025-10-07",
    orders: [
      { id: "ord_777", status: "cancelled", amount: 350, createdAt: "2025-10-09", responded: false, delivered: false, paid: false },
      { id: "ord_812", status: "cancelled", amount: 420, createdAt: "2025-11-02", responded: false, delivered: false, paid: false },
      { id: "ord_899", status: "returned", amount: 260, createdAt: "2025-12-22", responded: true, delivered: true, paid: true },
      { id: "ord_1201", status: "confirmed", amount: 180, createdAt: "2026-02-03", responded: true, delivered: true, paid: true },
    ],
  },
  {
    id: "cl_1003",
    fullName: "Khadija Ait Lahcen",
    phone: "+212 6 55 00 11 22",
    email: "khadija@example.com",
    city: "Marrakech",
    address: "Gueliz, Bloc B",
    notes: "High value buyer, consistent.",
    manualRiskFlag: false,
    blocked: false,
    createdAt: "2025-07-20",
    orders: [
      { id: "ord_501", status: "confirmed", amount: 1299, createdAt: "2025-08-11", responded: true, delivered: true, paid: true },
      { id: "ord_640", status: "confirmed", amount: 699, createdAt: "2025-09-19", responded: true, delivered: true, paid: true },
      { id: "ord_702", status: "confirmed", amount: 999, createdAt: "2025-12-05", responded: true, delivered: true, paid: true },
    ],
  },
  {
    id: "cl_1004",
    fullName: "Unknown Lead (Fake)",
    phone: "+212 6 00 00 00 00",
    email: "fake@invalid.tld",
    city: "Casablanca",
    address: "N/A",
    notes: "Repeated refusals and fake address.",
    manualRiskFlag: true,
    blocked: true,
    createdAt: "2026-01-20",
    orders: [
      { id: "ord_1301", status: "cancelled", amount: 399, createdAt: "2026-01-21", responded: false, delivered: false, paid: false },
      { id: "ord_1333", status: "cancelled", amount: 599, createdAt: "2026-02-01", responded: false, delivered: false, paid: false },
    ],
  },
  {
    id: "cl_1005",
    fullName: "Amine Tazi",
    phone: "+212 6 22 33 44 55",
    email: "amine@example.com",
    city: "Tanger",
    address: "Centre Ville",
    notes: "",
    manualRiskFlag: false,
    blocked: false,
    createdAt: "2025-12-15",
    orders: [
      { id: "ord_1044", status: "returned", amount: 450, createdAt: "2025-12-18", responded: true, delivered: true, paid: true },
      { id: "ord_1122", status: "cancelled", amount: 220, createdAt: "2026-01-08", responded: true, delivered: false, paid: false },
      { id: "ord_1199", status: "confirmed", amount: 300, createdAt: "2026-02-05", responded: true, delivered: true, paid: true },
    ],
  },
];
